import { toast } from 'react-toastify';

import PDFDialog from '../components/modals/PDFDialog';
import QtyPrintComponent from '../components/form/QtyPrintComponent';
import usePdfDialogHook from '../../redux/hooks/usePdfDialogHook';
import Card from '../components/cards/Card';
import PageHeader from '../components/page/PageHeader';
import useUrlParams from '../hooks/useUrlParams';
import { isNullOrWhitespace } from '../helpers/string-helper';

// http://localhost:3000/liquidation?lotCode=WBS6500000&sequence=4&lpn=ABCDE

function LiquidationLabelGeneratorPage() {
  const { canGenerate, isPDFDialogOpen, setIsPDFDialogOpen, pdfBase64, print } = usePdfDialogHook();

  const { liquidationLotCode, liquidationSequence, liquidationLpn } = useUrlParams();

  const printLabel = async (printQty: number, apiUrl: string) => {
    if (printQty) {
      await print({
        apiUrl,
        data: {
          liquidationLotCode,
          printQty,
          preview: false,
          lpn: !isNullOrWhitespace(liquidationLpn) ? liquidationLpn : null
        }
      });
    } else toast.warn('Missing inputs');
  };

  return (
    <div className="flex flex-col w-full">
      <PageHeader headingText="Liquidation Label Generator" />
      <>
        <Card headerText="Liquidation Box Labels" className="mb-5">
          <QtyPrintComponent
            apiUrl="liquidation-box-label"
            canGenerate={canGenerate}
            showQtyButtons={false}
            generateButtonText="Generate Liquidation Box Label"
            printFn={printLabel}
          />
        </Card>

        <QtyPrintComponent
          apiUrl="liquidation-lot-code-label"
          canGenerate={canGenerate}
          showQtyButtons={true}
          generateButtonText="Generate Liquidation Lot Codes"
          printFn={printLabel}
          twoColumns={true}
          leftCardHeaderText="Liquidation Lot Codes"
          initPrintQty={liquidationSequence}
        />
        <PDFDialog isOpen={isPDFDialogOpen} setIsOpen={setIsPDFDialogOpen} pdf={pdfBase64} />
      </>
    </div>
  );
}

export default LiquidationLabelGeneratorPage;
